import { $list, $elParent } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from '../../utils/key'

const ITEM_SELECTOR = `[data-column-switcher-item]`
const TARGET_SELECTOR = `[data-column-switcher-target]`

export class ColumnSwitcher extends BaseComponent {
  mountComponent(): void {
    const items = $list(ITEM_SELECTOR, this)

    this.addListener(window, 'load', this.handleWindowLoad)

    items.forEach(item => {
      this.addListener(item, 'keydown', this.handleKeyDown)
      this.addListener(item, 'click', this.handleItemClick)
    })

    if (this.isEditor) {
      this.editor.on('SECTION_LOAD', this.handleSectionLoad)
    }
  }

  handleWindowLoad = (): void => {
    if (!this.isEditor) {
      this.init()
    }
  }

  handleSectionLoad = (event): void => {
    if (this.dataset.sectionId === event.detail.sectionId) {
      this.reset()
    }
  }

  handleItemClick = (event: MouseEvent): void => {
    event.preventDefault()

    const item = $elParent(ITEM_SELECTOR, event.target)

    if (item) {
      this.updateByCount(+(item.dataset.value || 1))
    }
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    event.preventDefault()

    if (isEnterKey(event)) {
      const item = $elParent(ITEM_SELECTOR, event.target)

      if (item) {
        this.updateByCount(+(item.dataset.value || 1))
      }
    }
  }

  updateByCount(newCount: number): void {
    this.setIndicator(newCount)
    this.updateGrid(newCount)
  }

  setIndicator(columnCount: number): void {
    const items = $list(ITEM_SELECTOR, this)

    items.forEach(item => {
      const value = +(item.getAttribute('data-value') || 1)
      item.classList.toggle('selected', value === columnCount)
    })
  }

  updateGrid(value: number): void {
    const target = $elParent(TARGET_SELECTOR, this)

    if (target) {
      target.style.setProperty(
        `--gsc-${this.dataset.columnSwitcherCssVariable}`,
        value.toString(),
      )
      localStorage.setItem(
        `products-${this.dataset.columnSwitcherCssVariable}`,
        value.toString(),
      )
    }
  }

  init(): void {
    const value = localStorage.getItem(
      `products-${this.dataset.columnSwitcherCssVariable}`,
    )

    if (!value || value === 'null') {
      return
    }

    const preparedValue = Number(value)

    if (preparedValue > 0) {
      this.updateByCount(preparedValue)
    }
  }

  reset(): void {
    if (!this.dataset.default) {
      return
    }

    this.updateByCount(Number(this.dataset.default))
  }
}
